export default "__VITE_ASSET__gbDPAZop__"